import React, { useEffect, useState } from "react";
import filter from "../assets/images/filter.png";
import exportPic from "../assets/images/export.png";
import { Link, useLocation } from "react-router-dom";
import Upcoming from "../components/challenges/upcoming/Upcoming";
import Ongoing from "../components/challenges/ongoing/Ongoing";
import Completed from "../components/challenges/completed/Completed";
import Leaderboard from "../components/challenges/leaderboard/Leaderboard";
import { useDispatch } from "react-redux";
import { activeTabFunc } from "../features/slices/challanges";
import { useSelector } from "react-redux";
import { canPerformAction } from "../utils/denyAccess";
const initailState = {
  upComing: true,
  ongoing: false,
  completed: false,
  leaderboard: false,
};
const ChallengesManagement = () => {
  const [iState, setUpdateState] = useState(initailState);
  const { upComing, ongoing, completed, leaderboard } = iState;
  const dispatch = useDispatch();
  const { activeTab } = useSelector((state) => {
    return state.challenges;
  });
  const handleSelect = (name) => {
    setUpdateState((prev) => ({
      ...prev,
      upComing: false,
      ongoing: false,
      completed: false,
      leaderboard: false,
      [name]: true,
    }));
    dispatch(activeTabFunc(name));
  };
  useEffect(() => {
    if (activeTab) {
      setUpdateState((prev) => ({
        ...prev,
        upComing: false,
        ongoing: false,
        completed: false,
        leaderboard: false,
        [activeTab]: true,
      }));
    }
  }, []);

  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="TitleBox justify-content-end">
          {upComing && canPerformAction("Challenges&Bounty") && (
            <Link to={"challengeAdd"} className="TitleLink">
              <i className="fa-solid fa-plus" /> Add New Challenges
            </Link>
          )}
          {/* {leaderboard && (
            <Link to="viewPrizeDetails" className="TitleLink ml-2">
              View Prize Details
            </Link>
          )} */}
        </div>
        <div className="Small-Wrapper">
          <div className="row">
            <div className="col-md-10">
              <div className="CommonTabs">
                <ul className="nav nav-pills nav-fill">
                  <li
                    className="nav-item"
                    onClick={() => handleSelect("upComing")}
                  >
                    <a className={`nav-link ${upComing ? "active" : ""}`}>
                      Upcoming
                    </a>
                  </li>
                  <li
                    className="nav-item"
                    onClick={() => handleSelect("ongoing")}
                  >
                    <a className={`nav-link ${ongoing ? "active" : ""}`}>
                      Ongoing
                    </a>
                  </li>
                  <li
                    className="nav-item"
                    onClick={() => handleSelect("completed")}
                  >
                    <a className={`nav-link ${completed ? "active" : ""}`}>
                      Completed
                    </a>
                  </li>
                  <li
                    className="nav-item"
                    onClick={() => handleSelect("leaderboard")}
                  >
                    <a className={`nav-link ${leaderboard ? "active" : ""}`}>
                      Leaderboard
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="tab-content">
            {upComing && <Upcoming />}
            {ongoing && <Ongoing />}
            {completed && <Completed />}
            {leaderboard && <Leaderboard />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChallengesManagement;
